/* Sales-call players: manual playback, native controls, no automatic chapter changes. */
(() => {
  document.querySelectorAll('[data-mini-player]').forEach(root => {
    if (root.dataset.playerReady) return;
    root.dataset.playerReady = 'true';
    const videos = [...root.querySelectorAll('video')];
    const chapters = [...root.querySelectorAll('[data-workshop-shot]')];
    const media = root.querySelector('.workshop-media');
    const enlarge = root.querySelector('[data-mini-enlarge]');
    const status = root.querySelector('[role="status"]');
    let active = 0;
    const close = document.createElement('button');
    close.type = 'button'; close.className = 'mini-video-close'; close.textContent = 'Close enlarged video'; close.hidden = true;
    media.append(close);
    const leave = () => { media.classList.remove('is-expanded'); close.hidden = true; enlarge.focus(); };
    close.addEventListener('click', leave);
    media.addEventListener('keydown', event => {
      if (event.key === 'Escape' && media.classList.contains('is-expanded')) { event.preventDefault(); leave(); }
      if (event.key === 'Tab' && media.classList.contains('is-expanded')) {
        if (event.shiftKey && document.activeElement === videos[active]) { event.preventDefault(); close.focus(); }
        else if (!event.shiftKey && document.activeElement === close) { event.preventDefault(); videos[active].focus(); }
      }
    });
    chapters.forEach((button, index) => button.addEventListener('click', () => {
      videos.forEach((video, i) => { video.pause(); video.hidden = i !== index; video.classList.toggle('is-active', i === index); });
      active = index;
      chapters.forEach((item, i) => { if (i === index) item.setAttribute('aria-current', 'step'); else item.removeAttribute('aria-current'); });
      status.textContent = button.textContent.trim() + ' selected. Use the player controls to play.';
      videos[active].focus();
    }));
    videos.forEach(video => {
      video.tabIndex = 0;
      video.addEventListener('error', () => { status.classList.remove('sr-only'); status.textContent = 'This clip could not load. Please try another clip or reload the page.'; });
    });
    enlarge.addEventListener('click', async () => {
      const video = videos[active];
      try {
        if (video.requestFullscreen) { await video.requestFullscreen(); return; }
        if (video.webkitEnterFullscreen && video.readyState > 0) { video.webkitEnterFullscreen(); return; }
      } catch (_) { /* Use the on-page enlarged player if fullscreen is unavailable. */ }
      media.classList.add('is-expanded'); close.hidden = false; close.focus();
    });
  });
})();
